import { Navigate, useParams } from 'react-router-dom';
import { DashboardProvider, useDashboard } from './context/DashboardContext';
import { useEvents } from './context/EventsContext';
import { DashboardShell } from './layout/DashboardShell';
import { ModuleToolbar } from './components/ModuleToolbar';
import { GeneralModule } from './modules/GeneralModule';
import { CommunicationModule } from './modules/CommunicationModule';
import { RoutinesModule } from './modules/RoutinesModule';
import { GamesModule } from './modules/GamesModule';
import { AIModule } from './modules/AIModule';
import { MusicModule } from './modules/MusicModule';

function ModulePage() {
  const { activeModule } = useDashboard();

  switch (activeModule) {
    case 'general':
      return <GeneralModule />;
    case 'communication':
      return <CommunicationModule />;
    case 'routines':
      return <RoutinesModule />;
    case 'games':
      return <GamesModule />;
    case 'ai':
      return <AIModule />;
    case 'music':
      return <MusicModule />;
    default:
      return null;
  }
}

function EventDashboardContent() {
  return (
    <>
      <ModuleToolbar />
      <div className="flex-1 overflow-y-auto p-6 bg-blue-100 dark:bg-background border-t border-l border-border rounded-tl-2xl">
        <ModulePage />
      </div>
    </>
  );
}

export default function EventDashboardApp() {
  const { eventId } = useParams<{ eventId: string }>();
  const { getEventById } = useEvents();
  const event = eventId ? getEventById(eventId) : undefined;

  if (!event) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <DashboardProvider event={event}>
      <DashboardShell mode="event" eventId={event.id}>
        <EventDashboardContent />
      </DashboardShell>
    </DashboardProvider>
  );
}
